/**
 * Site-wide configuration for external links used across CTAs.
 * Keeping these in one file means a URL change only needs to happen once.
 */
export const BOOK_TRIAL_URL = 'https://sciencesorted.tutorbird.com/';

// Reusable props for the "Book a free trial" external anchor.
export const BOOK_TRIAL_ANCHOR = {
  href: BOOK_TRIAL_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
};
